import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { GlobalSearchConnectorResult } from '@kempoweroyj/ngx-search-api-client';
import { Evse } from '@kempoweroyj/ngx-evse-api-client';

@Component({
    selector: 'ce-connector-pill',
    templateUrl: './connector-pill.component.html',
    styleUrls: ['./connector-pill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectorPillComponent {
    @Input() connector: Evse;
    @Input() globalSearchConnector: GlobalSearchConnectorResult;
    @Input() compact = false;
    @Input() clickable = false;
}
